// This file contains all of the information that should be easily accessible by components of the site

// Importantly, all external links are stored here so that
// between course updates, this is the only file that needs to
// be checked for updates

// SECURITY NOTE:
/* 
This entire file is sent to the client,
Any links that appear here (even if commented
out or set to "go live" later) are technically
accessible to people who care to look for them.

If you happen to be one of the savvy students that
has discovered this "treasure trove" of unreleased
material, congratulations! Neat find ;) However, please
be aware that even if an unreleased link exists here, it's probably
not live for a reason, and you probably shouldn't use anything
that we didn't intend for you to use yet. 

This is a tradeoff we make by choosing to simplify hosting of
the website with no significant backend logic. Now, go take
a security class!
*/

// DON'T TOUCH THIS
// Able to reference content in the public folder (PUB + "/...")
export const PUB = process.env.PUBLIC_URL;

// ------ EDIT STUFF BELOW THIS LINE ------

export const announcementInfo = {
  // Appears at the top of the screen attached to navbar,
  // if an announcement exists
  message: "We'd love to hear what you think, submit anonymous feedback!",
  buttonText: "Give Feedback",
  buttonLink:
    "https://docs.google.com/forms/d/e/1FAIpQLSfkjqjfdvUz6j93XTj-fDSI1LdxsEImchzzuX78ufv9L6F7NQ/viewform",
  // Set & Forget tools:
  autoReleaseDate: "Feb 21, 2026 09:45:00 EST", // Automatically shows announcement on this date/time EST
  autoDismissDate: "May 14, 2026 09:00:00 EST", // Automatically removes announcement on this date/time EST
  // Announcement will be shown on page load and manually dismissable between the above two dates
};

export const lectures: Lecture[] = [
  {
    name: "What is LfS?",
    date: "Jan 21",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/manifesto/manifesto.html",
    recordingLink: "",
    otherLinks: [
      {
        name: "Amazon AWS Zelkova (Whitepaper)",
        link: "https://aws.amazon.com/blogs/security/protect-sensitive-data-in-the-cloud-with-automated-reasoning-zelkova/",
      },
      {
        name: "Some Industrial Applications",
        link: "https://github.com/ligurio/practical-fm",
      },
    ],
  },
  {
    name: "Properties and Testing",
    date: "Jan 23",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/properties/pbt.html",
    recordingLink: "",
    liveCodeLink: "",
    otherLinks: [
      {
        name: "Reading: Choosing Properties for Property-Based Testing",
        link: "https://fsharpforfunandprofit.com/posts/property-based-testing-2/",
      },
    ],
  },
  {
    name: "Intro to Modeling in Froglet (Part 1, Basics)",
    date: "Jan 26",
    notesLink: "https://forge-fm.github.io/book/2026/chapters/ttt/ttt.html",
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/jan26_ttt.frg",
  },
  {
    name: "Intro to Modeling (Part 2, Transitions)",
    date: "Jan 28",
    notesLink: "",
    otherLinks: [
      {
        name: "Notes: Transitions (first part only)",
        link: "https://forge-fm.github.io/book/2026/chapters/ttt/ttt_games.html",
      },
      {
        name: "Reading: How does Forge work?",
        link: "https://forge-fm.github.io/book/2026/chapters/qna/static.html",
      },
    ],
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/jan28_ttt.frg",
  },
  // notesLink: "https://forge-fm.github.io/book/2026/chapters/adder/rca.html",
  {
    name: "Design-Space Exploration and Visualization (BSTs)",
    date: "Jan 30",
    notesLink: "https://forge-fm.github.io/book/2026/chapters/bst/bst",
    recordingLink:
      "https://brown.zoom.us/rec/share/v8QU4qeYOCM3qkC3rKnPZVCxm_GfW0qYwZCd2d2ZtIo3Z8Ir1GBUjJDz1V2rl8WJ.mlHGEA_mkwy8MuCK?startTime=1769800236000",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/jan30_bst.frg",
    otherLinks: [
      {
        name: "Visualization",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/jan30_bst.cnd",
      },
      {
        name: "Zoom Recording",
        link: "https://brown.zoom.us/rec/share/PETfQ9Bfazl0J09h1vNZFGf80utX_owf1EKSDoXlSzJYfpKrP7FRvNr90bL-69HV.pt4PDeTloMC3KcKb?startTime=1769800236000",
      },
    ],
  },

  {
    name: "Contrasting Models and Q&A",
    date: "Feb 02",
    notesLink: "https://forge-fm.github.io/book/2026/chapters/qna/static.html",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/feb02_ttt.frg",
  },

  {
    name: "Finding Bad States (Part 1)",
    date: "Feb 04",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/inductive/bsearch.html",
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/feb04_ttt.frg",
  },

  {
    name: "Finding Bad States (Part 2, Preservation)",
    date: "Feb 06",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/inductive/bsearch.html",
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/feb06_binsearch.frg",
    otherLinks: [
      {
        name: "Starter",
        link: "https://forge-fm.github.io/book/2026/chapters/inductive/binarysearch_template.frg",
      },
    ],
  },
  {
    name: "Finding Bad States (Part 3)",
    date: "Feb 09",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/inductive/bsearch.html",
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/feb09_binsearch.frg",
    //otherLinks: []
  },

  {
    name: "Finding Traces",
    date: "Feb 11",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/ttt/ttt_games.html",
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/feb11_ttt.frg",
    otherLinks: [
      {
        name: "Exercise",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/ind1.py",
      },
      {
        name: "Exercise (Notes)",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/ind1_completed.py",
      },
    ],
  },

  //

  {
    name: "Validation and Q&A",
    date: "Feb 13",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/validation/validating_events.html",
    recordingLink: "",
    // liveCodeLink: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/feb13_ttt.frg",
    otherLinks: [
      {
        name: "Exercise",
        link: "https://docs.google.com/forms/d/e/1FAIpQLSd8BA9DUBAGaUVyZziGItQks_fHOZbPIV8Q8yH6L2tQa1p2uA/viewform?usp=publish-editor",
      },
    ],
  },
  {
    name: "Modeling syntax, semantics, and sets: Relational Forge",
    date: "Feb 18",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/relations/modeling-booleans-1.html",
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/boolean.py",
    otherLinks: [
      {
        name: "Exercise",
        link: "https://docs.google.com/forms/d/e/1FAIpQLScJEC7lcPAMPD7AIXDWX21v6OK3gALXstCxFD0JOGbr4H5_qw/viewform?usp=publish-editor",
      },
    ],
  },
  {
    name: "Modeling syntax, semantics, and sets: Relational Forge",
    date: "Feb 21",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/relations/modeling-booleans-1.html",
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/boolean.frg",
  },
  {
    name: "Cancelled due to snow",
    date: "Feb 23",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Join and Reachability",
    date: "Feb 25",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/relations/reachability.html",
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/boolean.frg",
    otherLinks: [
      {
        name: "Exercise",
        link: "https://docs.google.com/forms/d/e/1FAIpQLSddiMR0jxTQ-ZZ7Ri8nEvTjMygRYH40e1jA5WjVVBiHJvVA2Q/viewform?usp=publish-editor",
      },
      {
        name: "Visualization",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/boolean.cnd",
      },
    ],
  },
  {
    name: "Modeling Mutex (Part 1)",
    date: "Feb 27",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/relations/sets-induction-mutex.html",
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/feb27_mutex.frg",
  },
  {
    name: "Modeling Mutex (Part 2)",
    date: "Mar 02",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/relations/sets-induction-mutex.html",
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/mar02_mutex.frg",
    otherLinks: [
      {
        name: "Starter Model",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/mar02_mutex_starter.frg",
      },
      {
        name: "Starter Tests",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/mutex.test.frg",
      },
    ],
  },
  {
    name: "Liveness and Lassos",
    date: "Mar 04",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/temporal/liveness_and_lassos.html",
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/mar04_counter.frg",
    otherLinks: [
      {
        name: "Exercise",
        link: "https://docs.google.com/forms/d/e/1FAIpQLSd8-x69XYR08TywrCVsdTLNYxwPZPKoujFPO0xa_f7zG0uDTw/viewform?usp=publish-editor",
      },
      {
        name: "Notes part 2",
        link: "https://forge-fm.github.io/book/2026/chapters/temporal/temporal_operators.html",
      },
      {
        name: "Reminder: BST supplement with testing examples",
        link: "https://forge-fm.github.io/book/2026/chapters/bst/bst.html",
      },
    ],
  },
  {
    name: "Temporal Forge",
    date: "Mar 06",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/temporal/temporal_operators.html",
    recordingLink: "",
    liveCodeLink:
      "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/mar06_mutex.frg",
    otherLinks: [
      {
        name: "More Notes",
        link: "https://forge-fm.github.io/book/2026/chapters/temporal/temporal_operators_2.html",
      },
    ],
  },
  // {
  //   name: "Modeling Mutex (Part 3, Temporally)",
  //   date: "Mar 09",
  //   notesLink:
  //     "",
  //   recordingLink: "",
  //   liveCodeLink:
  //     "",
  // },
  {
    name: "Obligations and the Past",
    date: "Mar 09",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/temporal/obligations_past.html",
    recordingLink: "",
    liveCodeLink: "",
    otherLinks: [
      {
        name: "Traffic lights model",
        link: "https://forge-fm.github.io/book/2026/chapters/temporal/traffic.frg",
      },
      {
        name: "Tutor Exercise (do 4+)",
        link: "http://ltl-tutor.xyz/login?user_type=course-student&course_id=CSCI+1710+S26",
      },
    ],
  },

  {
    name: "LTL Exercise, How Forge Works",
    date: "Mar 11",
    notesLink: "https://forge-fm.github.io/book/2026/chapters/solvers/bounds_booleans_how_forge_works.html",
    recordingLink: "",
    liveCodeLink: "",
    otherLinks: [
      {name: "Read this week: Solving SAT", link: "https://forge-fm.github.io/book/2026/chapters/solvers/dpll.html"},
      {name: "Read this week: How Forge Works", link: "https://forge-fm.github.io/book/2026/chapters/solvers/bounds_booleans_how_forge_works.html"},
      // {name: "Exercise", link: "http://ltl-tutor.xyz/exercise/predefined?sourceuri=instructor:5"}
    ]
  },

  {
    name: "Constraint Propagation",
    date: "Mar 13",
    notesLink:
      "",
    recordingLink: "",
    liveCodeLink:
      "",
    otherLinks: [
      {
        name: "In-class Starter",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/jan26_ttt.frg",
      },
    ],
  },

  {
    name: "Final Projects, Resolution (Part 1)",
    date: "Mar 16",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/solvers/resolution.html",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Resolution (Part 2)",
    date: "Mar 18",
    notesLink:
      "https://forge-fm.github.io/book/2026/chapters/solvers/resolution.html",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Final Project Advice, Q&A",
    date: "Mar 20",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "No class (Spring break)",
    date: "Mar 23",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },
{
    name: "No class (Spring break)",
    date: "Mar 25",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "No class (Spring break)",
    date: "Mar 27",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },

  {
    name: "Satisfiability Modulo Theories (1)",
    date: "Mar 30",
    notesLink: "https://forge-fm.github.io/book/2026/chapters/solvers/smt.html",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Satisfiability Modulo Theories (2)",
    date: "Apr 01",
    notesLink: "https://forge-fm.github.io/book/2026/chapters/solvers/smt.html",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Satisfiability Modulo Theories (3)",
    date: "Apr 03",
    notesLink: "https://forge-fm.github.io/book/2026/chapters/solvers/smt.html",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Applications to Code (Symbolic Exe)",
    date: "Apr 06",
    notesLink: "https://forge-fm.github.io/book/2026/chapters/on_code/symbolic-execution.html",
    recordingLink: "",
    liveCodeLink: "https://forge-fm.github.io/book/2026/chapters/on_code/in-class.py",
  },
  {
    name: "Applications to Code (CEGIS)",
    date: "Apr 08",
    notesLink: "https://forge-fm.github.io/book/2026/chapters/solvers/cegis.html",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Applications to Code (CEGIS)",
    date: "Apr 10",
    notesLink: "https://forge-fm.github.io/book/2026/chapters/solvers/cegis.html",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "OPTIONAL: Future of 1710",
    date: "Apr 13",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Little Tricky Logic: Game of Life",
    date: "Apr 15",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/gameOfLife_inclass_end.frg",
    otherLinks: [
      {
        name: "In-class Starter",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/gameOfLife_inclass.frg",
      },
      {
        name: "In-class Visualization",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/gameOfLife_inclass.js",
      },
      {
        name: "Exercise",
        link: "https://docs.google.com/forms/d/e/1FAIpQLSfNpcgByzmHYFukaonm7QxM1XCgfjZBXyiHaGZ4exeh5DlHJQ/viewform?usp=publish-editor",
      },
      {
        name: "GoL Viewer",
        link: "https://golly.sourceforge.io/webapp/golly.html"
      },
      {
        name: "Relational Frg Version",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/gameOfLife_complete.frg",
      },

    ],
  },
  {
    name: "Explicit-State vs. Symbolic",
    date: "Apr 17",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
    otherLinks: [
      {
        name: "Graph Coloring (Forge)",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/spin/graph_color.frg",
      },
      {
        name: "Graph Coloring (Spin)",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/spin/graph_color_open.pml",
      },
      {
        name: "Hygienic Dining Smiths (Spin)",
        link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/spin/smiths_hygienic.pml",
      },
      // {
      //   name: "Game of Life Oscillators (Spin)",
      //   link: "https://github.com/csci1710/2026/blob/main/my-app/public/livecode/2026/spin/graph_color_open.pml",
      // },

    ],
  },
  {
    name: "Solving with Data Structures",
    date: "Apr 20",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },
  // {
  

  //{
  //   name: "Deadlocks, Peterson's Lock (Part 1)",
  //   date: "Mar 14",
  //   notesLink:
  //     "https://csci1710.github.io/book/chapters/temporal/fixing_lock_temporal.html",
  //   recordingLink: "",
  //   liveCodeLink:
  //     "https://github.com/csci1710/2025/blob/main/my-app/public/livecode/2025/mar14_mutex.frg",
  //   otherLinks: [
  //     {
  //       name: "In-class Starter",
  //       link: "https://github.com/csci1710/2025/blob/main/my-app/public/livecode/2025/mar14_starter.frg",
  //     },
  //   ],
  // },
  // {
  //   name: "Peterson's Lock (Part 2)",
  //   date: "Mar 17",
  //   notesLink:
  //     "https://csci1710.github.io/book/chapters/temporal/fixing_lock_temporal.html",
  //   recordingLink: "",
  //   liveCodeLink:
  //     "https://github.com/csci1710/2025/blob/main/my-app/public/livecode/2025/mar17_mutex.frg",
  // },
  // {
  //   name: "Finishing Mutex, How Forge Works",
  //   date: "Mar 19",
  //   notesLink:
  //     "https://csci1710.github.io/book/chapters/solvers/bounds_booleans_how_forge_works.html",
  //   recordingLink: "",
  //   liveCodeLink:
  //     "https://github.com/csci1710/2025/blob/main/my-app/public/livecode/2025/mar19_bounds.frg",
  //   otherLinks: [
  //     {
  //       name: "Fixing Peterson",
  //       link: "https://github.com/csci1710/2025/blob/main/my-app/public/livecode/2025/mar17_mutex.frg",
  //     },
  //   ],
  // },
  // {
  //   name: "Q&A, Debugging Tips",
  //   date: "Mar 21",
  //   notesLink: "",
  //   recordingLink: "",
  //   liveCodeLink:
  //     "https://github.com/csci1710/2025/blob/main/my-app/public/livecode/2025/assert_ltl.frg",
  // },
  // {
  //   name: "Solving SAT (Part 1)",
  //   date: "Mar 31",
  //   notesLink: "https://csci1710.github.io/book/chapters/solvers/dpll.html",
  //   recordingLink: "",
  //   liveCodeLink: "",
  // },
  // {
  //   name: "Solving SAT (Part 2)",
  //   date: "Apr 02",
  //   notesLink: "https://csci1710.github.io/book/chapters/solvers/dpll.html",
  //   recordingLink: "",
  //   liveCodeLink: "",
  // },
  // {
  //   name: "Resolution (Part 1)",
  //   date: "Apr 04",
  //   notesLink:
  //     "https://csci1710.github.io/book/chapters/solvers/resolution.html",
  //   recordingLink: "",
  //   liveCodeLink: "",
  // },
  // {
  //   name: "Resolution (Part 2)",
  //   date: "Apr 07",
  //   notesLink:
  //     "https://csci1710.github.io/book/chapters/solvers/resolution.html",
  //   recordingLink: "",
  //   liveCodeLink: "",
  // },
  // {
  //   name: "Resolution (Part 3)",
  //   date: "Apr 09",
  //   notesLink:
  //     "https://csci1710.github.io/book/chapters/solvers/resolution.html",
  //   recordingLink: "",
  //   liveCodeLink: "",
  // },
  // {
  //   name: "(Optional) Future of 1710",
  //   date: "Apr 11",
  //   notesLink: "",
  //   recordingLink: "",
  //   liveCodeLink: "",
  // },
  // {
  //   name: "SMT (Whirlwind Tour)",
  //   date: "Apr 14",
  //   notesLink: "",
  //   recordingLink: "",
  //   liveCodeLink: "",
  // },
  // {
  //   name: "SMT (Applications)",
  //   date: "Apr 16",
  //   notesLink: "",
  //   recordingLink: "",
  //   liveCodeLink: "",
  // },
  // {
  //   name: "Guest: Milda Zizyte",
  //   date: "Apr 18",
  //   notesLink: "",
  //   recordingLink: "",
  //   liveCodeLink: "",
  // },
  // {
  //   name: "SMT (CEGIS, Closing)",
  //   date: "Apr 21",
  //   notesLink: "",
  //   recordingLink: "",
  //   liveCodeLink: "",
  // },


  {
    name: "Guest Speaker: Saad Ullah (Boston U)",
    date: "Apr 22",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Guest Speaker: Anjali Pal (UW)",
    date: "Apr 24",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Guest Speakers: James Larisch and Suleman Ahmad (Cloudflare)",
    date: "Apr 27",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Guest Speaker: Benjamin Simon (Downdog)",
    date: "Apr 29",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Guest: Zachary Espiritu (MongoDB Research)",
    date: "May 1",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },
  {
    name: "Guest Speaker: Prof. Milda Zizyte (Brown)",
    date: "May 4",
    notesLink: "",
    recordingLink: "",
    liveCodeLink: "",
  },
];

// For assignments, exclude HREF field to automatically disable the assignment
export const homeworkAssignments: Assignment[] = [
  {
    name: "PBT",
    dateRange: "Jan 23 → Jan 29, 2026",
    href: "https://hackmd.io/@csci1710/rkWPh6tN-l",
    autoReleaseDate: "Jan 23, 2026 15:00:00 EST",
  },
  {
    name: "Modeling Intro",
    dateRange: "Jan 30 → Feb 5, 2026",
    href: "https://hackmd.io/@csci1710/B1NEG7jKa",
    autoReleaseDate: "Jan 30, 2026 15:00:00 EST",
  },
  {
    name: "Physical Keys",
    dateRange: "Feb 6 → Feb 12, 2026",
    href: "https://hackmd.io/@csci1710/ByLnzQstT",
    autoReleaseDate: "Feb 6, 2026 15:00:00 EST",
  },
  {
    name: "Memory Management",
    dateRange: "Feb 27 → Mar 5, 2026",
    href: "https://hackmd.io/@csci1710/S1xVNmiK6",
    autoReleaseDate: "Feb 27, 2026 15:00:00 EST",
  },
  {
    name: "Temporal Modeling",
    dateRange: "Mar 6 → Mar 12, 2026",
    href: "https://hackmd.io/@csci1710/HJk8E7jFa",
    autoReleaseDate: "Mar 6, 2026 15:00:00 EST",
  },
  {
    name: "SAT",
    dateRange: "Mar 13 → Mar 19, 2026",
    href: "https://hackmd.io/@csci1710/SJvrLGYH-g",
    autoReleaseDate: "Mar 13, 2026 15:00:00 EDT",
  },
  {
    name: "SMT 1",
    dateRange: "Apr 3 → Apr 9, 2026",
    href: "https://hackmd.io/@csci1710/rkzzBmoYa",
    autoReleaseDate: "Apr 3, 2026 15:00:00 EDT",
  },
  {
    name: "SMT 2",
    dateRange: "Apr 10 → Apr 16, 2026",
    href: "https://hackmd.io/@csci1710/HyCHj6CEZx",
    autoReleaseDate: "Apr 10, 2026 15:00:00 EDT",
  },
  // {
  //   // Rickroll ;)
  //   name: "Hardest Assignment Ever...",
  //   dateRange: "Oct 25 → Oct 26, 2009",
  //   href: "https://www.youtube.com/watch?v=xvFZjo5PgG0",
  //   autoReleaseDate: "Jan 25, 2026 21:28:59 EST",
  // },
  // ...
];

export const labAssignments: Assignment[] = [
  {
    name: "(Optional) Async Python",
    dateRange: "Jan 21, 2026",
    href: "https://hackmd.io/@csci1710/By-lPmstT",
    autoReleaseDate: "Jan 21, 2026 09:45:00 EST",
  },
  // {
  //   name: "Tic Tac Toe",
  //   dateRange: "Jan 28 → Jan 29, 2026",
  //   href: "https://hackmd.io/@csci1710/HkOLBXstT",
  //   autoReleaseDate: "Jan 28, 2026 15:00:00 EST",
  // },
  {
    name: "N Queens",
    dateRange: "Feb 4 → Feb 5, 2026",
    href: "https://hackmd.io/@csci1710/BkYfImjKp",
    autoReleaseDate: "Feb 4, 2026 15:00:00 EST",
  },
  {
    name: "Ring Election",
    dateRange: "Feb 11 → Feb 12, 2026",
    href: "https://hackmd.io/@csci1710/ryC5S7jt6",
    autoReleaseDate: "Feb 11, 2026 15:00:00 EST",
  },
  {
    name: "Curiosity co-lab",
    dateRange: "Feb 18 → Feb 19, 2026",
  },
  {
    name: "Reference Counting",
    dateRange: "Feb 25 → Feb 26, 2026",
    href: "https://hackmd.io/@csci1710/S1LXKW2t6",
    autoReleaseDate: "Feb 25, 2026 15:00:00 EST",
  },
  {
    name: "Dining Blacksmiths",
    dateRange: "Mar 4 → Mar 5, 2026",
    href: "https://hackmd.io/@csci1710/HkbhU7sta",
    autoReleaseDate: "Mar 4, 2026 15:00:00 EST",
  },
  {
    name: "Sociotech Discussion",
    dateRange: "Mar 11 → Mar 12, 2026",
    href: "https://hackmd.io/@csci1710/rk66iLUDbl",
    autoReleaseDate: "Mar 11, 2026 15:00:00 EDT",
  },
  {
    name: "SAT co-lab",
    dateRange: "Mar 18 → Mar 19, 2026",
  },
  {
    name: "Proposal co-lab",
    dateRange: "Apr 1 → Apr 2, 2026",
  },
];

export const projectAssignments: Assignment[] = [
  {
    name: "Curiosity Modeling",
    dateRange: "Feb 13 → Feb 26, 2026",
    href: "https://hackmd.io/@csci1710/rJm6XmjKT",
    autoReleaseDate: "Feb 13, 2026 15:00:00 EST",
  },
  {
    name: "Final Project (Proposal)",
    dateRange: "Mar 20 → Apr 2, 2026",
    href: "https://hackmd.io/@csci1710/ByCXUZ2KT",
    autoReleaseDate: "Mar 20, 2026 15:00:00 EST",
  },
  {
    name: "Final Project",
    dateRange: "Apr 18 → May 7, 2026",
    href: "https://hackmd.io/@csci1710/ByCXUZ2KT",
    autoReleaseDate: "Apr 18, 2026 15:00:00 EST",
  },
];

// export const forgeDocsLink: string = "";
// export const EdStemLink: string = "";

export const FAQLink: string =
  "https://docs.google.com/document/d/e/2PACX-1vQek5FgRtgmr7rdxOnq5qzTIaRoVcc0dN4dERg5qu4oJ4hTCAmWJkrBbNWUdm_zsMRtQOmzpG17fWQK/pub";

export const policies: Resource[] = [
  {
    name: "Syllabus",
    href: "https://docs.google.com/document/d/1y5CHtZirUx7KxOqcSI4Byy9Pxvu3tauPPniZuGUqiks/edit?usp=sharing",
  },
  {
    name: "Guide to Effective AI Use",
    href: "https://docs.google.com/document/d/1_uj3kxTXzTSVpDodqQpLLaCZKT5y9x-oznn3cnlx4SQ/edit?usp=sharing",
  },
  // {
  //   name: "Collaboration Policy",
  //   href: "",
  //   // "https://docs.google.com/document/d/e/2PACX-1vQ7b5GLg6Kie0l4zzuLLQ7oaC89V931dqbHQl7Rgr7sVT05bIu1WrGTcNaGpn9gg5y9Tc7GvLS32vf1/pub",
  // },
];

export const importantLinks: Resource[] = [
  {
    name: "EdStem",
    href: "https://edstem.org/us/join/V9WucK",
  },
  { name: "Hours", href: "https://hours.cs.brown.edu/login" },
  {
    name: "Collaboration Form",
    href: "https://forms.gle/dHaaedpVFh7k4D1x9",
  },
  {
    name: "Brown CS Health and Wellness",
    href: "https://cs.brown.edu/about/diversity/resources/",
  },
  {
    name: "Ever True Resources",
    href: "https://evertrue.brown.edu/resources/",
  },
];

export const guides: Resource[] = [
  {
    name: "Setup & Installation",
    href: "https://hackmd.io/@csci1710/r1rZAWeo6",
  },
  {
    name: "Forge Book",
    href: "https://forge-fm.github.io/book/2026",
  },
  {
    name: "Forge Tool Documentation",
    href: "https://forge-fm.github.io/forge-documentation/5.0",
  },
  // {
  //   name: "Toadus Ponens Guide",
  //   href: "",
  //   // "https://docs.google.com/document/d/1zdv6uF7jdC8CR-d73AojsH68jaLmNG3MwlcZ9R2lWpc/edit?usp=sharing",
  // },
  {
    // Goes live later in semester
    name: "Python Z3",
    href: "", // Greyed out for now
    // href: "https://docs.google.com/document/d/1ri_-SadZ-IWqrg3ZNY6tJRB_0OSDdwJRYNtdHkSehuc/preview",
  },
];

export const professor: staffMember = {
  name: "Tim Nelson",
  image: PUB + "/images/staff/tim.jpeg",
  alt_image: PUB + "/images/staff/tim_frog.jpeg",
  alt_objectPosition: "90% 50%",
  pronouns: "he/they",
  bio: 'I’m a first-generation college student who attended community college, a state college, the "college" of an industry job, and a STEM university. Now I teach at Brown. You might call this a collage of colleges, although not quite a universe of universities.',
  favorite_amphibian: "Neutral (as a professor, I can't play favorites!)",
  role: "Professor",
  // favorite_amphibian_image: "",
};

export const htas: staffMember[] = [
  {
    name: "Sarah Ridley",
    image: PUB + "/images/staff/sarah.JPG",
    objectPosition: "center 65%",
    // alt_image: PUB + "/images/staff/megan_frog.jpeg",
    pronouns: "she/her",
    bio: "Hi! I'm a senior from North Carolina studying computer science. This is my second year as an HTA for 1710, and I'm so excited for this spring! Outside of cs, I love sewing, baking, my cat, and doing jigsaw puzzles.",
    favorite_amphibian: "Team Frog",
    role: "HTA",
  },
];

export const utas: staffMember[] = [
  {
    name: "Ruth Ukubay",
    image: PUB + "/images/staff/ruth.jpeg",
    alt_objectPosition: "center 65%",
    pronouns: "she/her",
    bio: "Hi! I’m Ruth, a senior concentrating in Computer Science from Ethiopia:) I love pickleball and do a lot of restaurant hopping in my free time. I am so excited to be your TA this semester!",
    favorite_amphibian: "Team Toad",
    role: "UTA",
  },

  {
    name: "Dior Williams",
    image: PUB + "/images/staff/dior.jpg",
    objectPosition: "center 15%",
    // alt_image: PUB + "/images/staff/conrad_frog.jpeg",
    alt_objectPosition: "center 25%",
    pronouns: "she/her",
    bio: "Hi, I am a senior from Houston, Texas. I love playing video games, watching movies, and this is my first time TAing a CS class. I'm usually in the EEPS department, so feel free to ask me questions about that too. :)",
    favorite_amphibian: "Team Toad",
    role: "UTA",
  },
  {
    name: "Joshua Kou",
    image: PUB + "/images/staff/joshua.jpg",
    objectPosition: "center 35%",
    // alt_image: PUB + "/images/staff/kendra_frog.jpeg",
    pronouns: "he/him",
    bio: "Hi I'm Joshua, a sophomore studying math and cs from Austin, Texas. I enjoy learning number theory and playing board/card/social deduction games. I love talking about or being introduced to anything in those categories!",
    favorite_amphibian: "Team Frog",
    role: "UTA",
  },
  {
    name: "Snoop Frogg",
    image: PUB + "/images/staff/snoop.jpg",
    objectPosition: "center 40%",
    alt_image: PUB + "/images/staff/snoop_alt.jpg",
    pronouns: "he/they",
    bio: '"Rapper, producer, formal method and modeler."',
    favorite_amphibian: "Team Frog, duh",
    role: "UTA",
  },
];

export const gradtas: staffMember[] = [
  {
    name: "Siddhartha Prasad",
    image: PUB + "/images/staff/siddhartha.jpeg",
    alt_image: PUB + "/images/staff/siddhartha_frog.jpeg",
    bio: "“Frog pushed a coat down over the top of Toad. Frog pulled snowpants up over the bottom of Toad. He put a hat and scarf on Toad’s head. ‘Help!’ cried Toad. ‘My best friend is trying to kill me!’ ‘I’m only getting you ready for winter,’ said Frog. ”",
    pronouns: "he/him",
    favorite_amphibian: "Team Toad",
    role: "Grad TA",
  },
  {
    name: "Toadus Ponens",
    image: PUB + "/images/staff/algo_ribbit.jpeg",
    //alt_image: PUB + "/images/staff/algo_ribbit_alt.jpeg",
    bio: "Croak",
    pronouns: "he/they",
    favorite_amphibian: "Team Toad, obviously",
    role: "Grad TA",
  },
];

export const calendarLink =
  "https://calendar.google.com/calendar/u/0?cid=Y19kMWViODZjMzFlODU4NjZmOTEwYmUyM2MyZjQzYTFlMWI1YWQwZmFiOGZkNDczZDlkM2NhNDY4NzNkM2Y0YTExQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20";
// Type definitions

export type Resource = {
  name: string;
  href: string;
};

export type Lecture = {
  name: string;
  date: string; // Jan 28
  description?: string; // Short 1-2 sentence lecture description, optional
  notesLink?: string;
  recordingLink?: string;
  liveCodeLink?: string;
  // Arbitrary links with arbitrary names:
  otherLinks?: { name: string; link: string }[]; // NOTE: Nothing preventing name conflict between notes/recording/livecode name
};

// export type LectureWeek = {
//   name: string; // week X
//   dailyLectures: Lecture[];
// };

export type Assignment = {
  name: string;
  dateRange: string;
  href?: string; // If left blank, assignment appears as disabled
  autoReleaseDate?: string; // Will treat href as "blank" until this date/time (EST)
};

export type staffMember = {
  name: string;
  image: string;
  objectPosition?: string; // Fix image alignment if necessary (on mobile wrong part of image gets cut off)
  alt_image?: string; // On image hover, the image changes to alt image
  alt_objectPosition?: string; // Same as objectPosition but for alt image
  pronouns: string;
  bio: string;
  favorite_amphibian: string;
  role: string; // prof/hta/uta/sta...
  // favorite_amphibian_image: string;
};
